import { fetchSearchResultsLogic } from './fetchSearchResultsLogic';
import { updateQueryLogic } from './updateQueryLogic';
import { clearFiltersLogic } from './clearFiltersLogic';
import { routeToPropertyLogic } from './routeToPropertyLogic';

export const logic = [fetchSearchResultsLogic, updateQueryLogic, clearFiltersLogic, routeToPropertyLogic];
